import ArtworkTile from "./ArtworkTile";

export default ArtworkTile;
